import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OutsourcedStatusEnum from '../../../Enums/OutsourcedStatusEnum';

export default class OutsourcedJobLinkSearchParams extends SearchParamsBase {
  static saveType = 'OutsourcedJobLinkSearchParams';

  initialize() {
    this.ClientIds = [];
    this.ProjectIdOrName = '';
    this.UserIds = [];
    this.FieldworkOfficeIds = [];
    this.OutsourcingOfficeIds = [];
    this.Status = [OutsourcedStatusEnum.ReadyForInvoicing, OutsourcedStatusEnum.ApprovedForInvoicing];
    this.CampaignName = '';
    this.ThirdPartySources = [];
    this.SurveyIds = [];
    this.TpSurveyIds = [];
    this.ThirdPartyJobIds = '';
  }

  static fieldsInSearchBox = [
    {
      fieldName: 'ClientIds',
      label: 'Client',
      className: 'col-3',
      type: InputTypesEnum.ClientMultiChoice,
    },
    {
      fieldName: 'ProjectIdOrName',
      label: 'Project (Bravo ID or Name)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'UserIds',
      label: 'User',
      className: 'col-3',
      type: InputTypesEnum.UserMultiSelect,
    },
    // Work Done By before Bill To Office, as on every other outsourced surface: the office that does the work,
    // then the office it is billed to. The two are easy to confuse, so the order never varies (CD-5079).
    {
      fieldName: 'OutsourcingOfficeIds',
      label: 'Work Done By',
      className: 'col-3',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'FieldworkOfficeIds',
      label: 'Bill To Office',
      className: 'col-3',
      type: InputTypesEnum.OfficeMultiSelect,
    },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-3',
      type: InputTypesEnum.MultiChoice,
      options: OutsourcedJobLinkSearchParams.getStatusList(),
    },
    {
      fieldName: 'CampaignName',
      label: 'Campaign (exact match)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ThirdPartySources',
      label: 'Third Party Source',
      className: 'col-3',
      type: InputTypesEnum.ThirdPartySourceMultiChoice,
    },
    {
      fieldName: 'SurveyIds',
      label: 'Survey',
      className: 'col-3',
      type: InputTypesEnum.SurveyMultiChoice,
    },
    {
      fieldName: 'TpSurveyIds',
      label: 'TP Survey',
      className: 'col-3',
      type: InputTypesEnum.TpSurveyMultiChoice,
    },
    {
      fieldName: 'ThirdPartyJobIds',
      label: 'Third Party Job ID (id1,id2,...)',
      className: 'col-3',
      type: InputTypesEnum.Text,
    },
  ];

  static getStatusList() {
    return [
      { value: OutsourcedStatusEnum.Collected, label: 'Collected' },
      { value: OutsourcedStatusEnum.FeeAttached, label: 'Fee Attached' },
      { value: OutsourcedStatusEnum.ReadyForInvoicing, label: 'Ready For Invoicing' },
      { value: OutsourcedStatusEnum.ApprovedForInvoicing, label: 'Approved For Invoicing' },
      { value: OutsourcedStatusEnum.Invoiced, label: 'Invoiced' },
      { value: OutsourcedStatusEnum.Uninvoiceable, label: 'Uninvoiceable' },
    ];
  }
}
